import { FC, PropsWithChildren } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { AssistantTitle } from './assistant-title';
import { GradientBar } from './gradient-bar';
import { HeaderBar } from './header-bar';
import { PanelControls } from './panel-controls';

interface AssistantHeaderProps {
  containerStyles?: Interpolation<Theme>;
}
interface AssistantHeaderNamespace extends FC<PropsWithChildren<AssistantHeaderProps>> {
  Title: typeof AssistantTitle;
  HeaderBar: typeof HeaderBar;
  PanelControls: typeof PanelControls;
  GradientBar: typeof GradientBar;
}

export const AssistantHeader: AssistantHeaderNamespace = ({ children, containerStyles }) => {
  return <div css={containerStyles}>{children}</div>;
};

AssistantHeader.Title = AssistantTitle;
AssistantHeader.HeaderBar = HeaderBar;
AssistantHeader.PanelControls = PanelControls;
AssistantHeader.GradientBar = GradientBar;
